import { render, staticRenderFns } from "./HeaderAvatar.vue?vue&type=template&id=14d2160e"
import script from "./HeaderAvatar.vue?vue&type=script&lang=js"
export * from "./HeaderAvatar.vue?vue&type=script&lang=js"
import style0 from "./HeaderAvatar.vue?vue&type=style&index=0&id=14d2160e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports